import { Directive, AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ISettings } from 'src/app/core/interfaces';

export let defaultLanguage = '';

@Directive({
    selector: '[asgRootLang]',
    standalone: true
})
export class RootLangDirective implements AfterViewInit, OnDestroy {
  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private readonly translate: TranslateService,
    private readonly settingsService: SettingsService
  ) {
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    this.onSettingsChange();
    this.init();
  }

  init() {
    defaultLanguage = environment.defaultLangCode;
    this.translate.addLangs([defaultLanguage]);
    this.translate.setDefaultLang(defaultLanguage);
    this.translate.use(defaultLanguage);
  }

  private onSettingsChange() {
    this.subscriptions.add(
      this.settingsService.getSettingsObservable().subscribe((e: ISettings) => {
        defaultLanguage = e.UILanguageValue;
      })
    );
  }

}
